import { put, select, takeLatest } from 'redux-saga/effects'
import { convertSecondsToMin } from '../../../utilities/dateTime.util'
import { getUserSelector } from '../../user/selectors'
import { IUserState } from '../../user/store/user.types'
import {
  setBase,
  setShift,
  setStaffingLevel,
  setVehicle,
  setCrewList,
  setRegistrationTailNumber,
  setUnitEquipment,
  setPrimaryMonitor,
} from '../store/crew.actions'
import { CrewConstants } from '../store/crew.constants'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { getCrewSelector } from '../selectors/getCrew.selector'
import { ICrewState } from '../store/crew.types'
import { initialCrewState } from '../store/crew.reducers'

export function* getPersistShiftStartupData() {
  const userState: IUserState = yield select(getUserSelector)
  const { serviceId, userId } = userState
  const { STAFF_DEFAULT } = yield select(getServiceConfigSelector)
  const crew: ICrewState = yield select(getCrewSelector)
  const { staffingLevelOptions, primaryMonitor, registrationTailOptions, vehicleOptions } = crew
  const shiftStartup = localStorage.getItem(`shiftStartupData:${userId}:${serviceId}`)
  const defaultStaffingLevel = staffingLevelOptions.find((option) => option.id === STAFF_DEFAULT)
  if (shiftStartup) {
    const shiftStartupData = JSON.parse(shiftStartup)
    const { shift, base, staffingLevel, vehicle, crewList, timestamp, registrationTailNumber, unitEquipment } =
      shiftStartupData
    const currentTimeStamp = new Date().valueOf()
    const dataTimeStamp = new Date(timestamp).valueOf()
    const timeDifference = convertSecondsToMin(currentTimeStamp - dataTimeStamp)
    const expirationTime = Number(process.env.REACT_APP_PERSIST_SHIFT_MINUTES) || 720
    const getRegistrationTailNumber = registrationTailOptions?.find(
      (regTail) => regTail?.id === registrationTailNumber?.id
    )
    const getVehicle = vehicleOptions?.find((unit) => unit?.id === vehicle?.id) ?? vehicle
    if (timeDifference < expirationTime) {
      yield put(setShift(shift))
      yield put(setBase(base))
      yield put(setStaffingLevel(staffingLevel || defaultStaffingLevel))
      yield put(setVehicle(getVehicle))
      yield put(setRegistrationTailNumber(getRegistrationTailNumber ?? initialCrewState.registrationTailNumber))
      yield put(setCrewList(crewList))
      yield put(setUnitEquipment(unitEquipment))
      yield put(setPrimaryMonitor(primaryMonitor))
    } else {
      yield put(setStaffingLevel(defaultStaffingLevel))
    }
  } else {
    yield put(setStaffingLevel(defaultStaffingLevel))
  }
}

export function* getPersistShiftStartupDataSaga() {
  yield takeLatest([CrewConstants.GET_PERSIST_SHIFT_STARTUP], getPersistShiftStartupData)
}
